export default __webpack_public_path__ + "static/media/EB4F071A-D75A-4EEE-8CDF-CC5D23D6EACC.7aa61f8a.jpeg";